import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
}

export const HangFireIcon = (props: IProps) => {
	const { className } = props;
	return (
		<SvgIcon className={className} height={689} width={689} viewBox='0 0 140 140'>
			<path
				fill='#014B7F'
				d='M86 141H1.038V1.1h139.8V141H86m-79.818-8.045c2.223 3.623 5.717 4.075 9.558 4.07 36.816-.043 73.632-.015 110.448-.033 8.142-.004 10.8-2.652 10.803-10.773.02-36.816.02-73.631 0-110.447-.004-8.112-2.668-10.76-10.817-10.764-36.816-.018-73.632-.017-110.448 0C7.692 5.012 5.01 7.74 5.006 15.88c-.013 36.816-.018 73.632.03 110.448.002 1.958.518 3.916 1.146 6.627z'
			/>
			<path
				fill='#FEFFFF'
				d='M6.006 132.578c-.452-2.334-.968-4.292-.97-6.25a65541.09 65541.09 0 0 1-.03-110.448C5.01 7.74 7.693 5.012 15.727 5.008c36.816-.017 73.632-.018 110.448 0 8.15.004 10.813 2.652 10.817 10.764.02 36.816.02 73.631 0 110.447-.004 8.121-2.66 10.769-10.803 10.773-36.816.018-73.632-.01-110.448.034-3.84.004-7.335-.448-9.734-4.448m34.162-94.955v73.082h16.534V76.384h31.452v34.29h15.721v-79.39h-16.05v30.34H56.392V31.358H40.168v6.264z'
			/>
			<path
				fill='#044D81'
				d='M40.168 37.141V31.36h16.224v30.264h31.433v-30.34h16.05v79.391h-15.72v-34.29H56.701v34.321H40.168V37.141z'
			/>
		</SvgIcon>
	);
};
